import {inject, Service} from '@angular/core'
import {forkJoin, Observable} from 'rxjs'
import {InterestService} from '../services/interest.service'

@Service()
export class InterestResolver {
  private readonly service = inject(InterestService)

  resolve(): Observable<any> {
    return forkJoin([this.service.getAllInterests(), this.service.getAllInterestTypes()])
  }
}
